import { render, staticRenderFns } from "./NewAppointment.html?vue&type=template&id=ba594c50&external"
import script from "./NewAppointment.js?vue&type=script&lang=js&external"
export * from "./NewAppointment.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports